import { render } from "./OutStockList.vue?vue&type=template&id=645cdd08&scoped=true"
import script from "./OutStockList.vue?vue&type=script&lang=js"
export * from "./OutStockList.vue?vue&type=script&lang=js"

import "./OutStockList.vue?vue&type=style&index=0&id=645cdd08&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645cdd08"],['__file',"src/views/h5/common/stock/outStock/OutStockList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "645cdd08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('645cdd08', __exports__)) {
    api.reload('645cdd08', __exports__)
  }
  
  module.hot.accept("./OutStockList.vue?vue&type=template&id=645cdd08&scoped=true", () => {
    api.rerender('645cdd08', render)
  })

}


export default __exports__